import Debouncer from '../../lib/Debouncer';
const variables = require('../../variables.js');
import ViewportTracker from '../../lib/ViewportTracker';

export default function init() {
	const imageHolder = document.querySelector('.slideDeck__imageHolder');
	if (!imageHolder) {
		return;
	}
	const image: HTMLElement = document.querySelector('.slideDeck__imageWrapWrapWrap');
	const firstSlide = document.querySelector('.slideDeck .slide');
	const firstSlideInner = document.querySelector('.slideDeck .slide__inner');

	let startWidth: number,
		startScrollPosition: number,
		scrollRange: number,
		endWidth: number,
		endHeight: number;

	const calculateSizes = () => {
		if (ViewportTracker.above("mobileMenu", false)) {
			//startWidth = imageHolder.clientWidth; // Restore if restoring max-width to imageHolder
			startWidth = window.innerWidth > (parseInt(variables.slideDeck_imageContainer_maxWidth) + 2 * parseInt(variables.defaultSpacing_H)) ? parseInt(variables.slideDeck_imageContainer_maxWidth) : window.innerWidth;
			startScrollPosition = window.innerHeight / 2;
			scrollRange = window.innerHeight * variables.slideDeck_scrollRange_viewportPercent;

			// endWidth = Math.round((startWidth - (startWidth - firstSlide.clientWidth + 2 * parseInt(variables.defaultSpacing_H)) / 2 - firstSlideInner.clientWidth)); // Restore if restoring max-width to imageHolder
			endWidth = Math.round((startWidth - (startWidth - firstSlide.clientWidth + 2 * parseInt(variables.defaultSpacing_H)) / 2 - firstSlideInner.clientWidth));
			
			//NOTE: turning off because CSS implementation looks less janky
			//endHeight = window.innerHeight - 33 * 2 - 100; // Design shows 33px space above and below image // TODO: 100 var
		}
	}
	
	const scrollDebouncer = new Debouncer(() => {
		if (ViewportTracker.above("mobileMenu", false)) {
			const scrollPosition = window.pageYOffset;
		
			if (scrollPosition < startScrollPosition) {
				// Need to unset width because sometimes width is terribly miscalculated
				image.style.width = '';
				//image.style.height = '';

				image.classList.remove('slideDeck__imageWrapWrapWrap--shrunk');
			} else if (scrollPosition >= startScrollPosition && scrollPosition <= (startScrollPosition + scrollRange)) {
				const newWidth = startWidth - ((scrollPosition - startScrollPosition) / scrollRange) * (startWidth - endWidth);

				image.style.width = `${newWidth}px`;
				//image.style.height = `${newHeight}px`;

				image.classList.add('slideDeck__imageWrapWrapWrap--shrunk');
			} else {
				// Needed because sometimes width never reaches final intended size, especially when scrolling fast
				image.style.width = `${endWidth}px`;
				//image.style.height = `${endHeight}px`;

				image.classList.add('slideDeck__imageWrapWrapWrap--shrunk');
			}
		} else {
			image.style.width = '';
		}
	}, true);

	calculateSizes();
	window.addEventListener('scroll', scrollDebouncer.run);
	window.addEventListener('resize', () => {
		new Debouncer(() => {
			calculateSizes();
		}).run();
	
		scrollDebouncer.run();
	});
}

		